<script>
import Vue from 'vue';

Vue.component('HTMLMenu', {
  data: function() {
    return {
      second_level_menus: [],
      third_level_menus: [],
      third_level_title: '',
      menus: this.$root.menus
    }
  },

  template: `
    <div>
      <div class="menu-column">
        <div class="hidden-scrollbar">
          <a v-on:click="setLevel1Menus(menu)" :id="menu.id" :key="menu.id" v-for="(menu, i) in menus" :href="getHref(menu.link)"><i :class="menu.icon"></i><span>{{ menu.label }}</span></a>
        </div>
      </div>
      <div class="menu-column-sub hide">
        <a v-on:click="setLevel2Menus(menu)" :id="menu.id" :key="menu.id" v-for="(menu, i) in second_level_menus" :href="getHref(menu.link)"><div class="icon"><i :class="menu.icon"></i><span>{{ menu.label }}</span></div></a>
      </div>
      <div class="menu-column-sub2 hide">
        <div v-on:click="secondLevelMenusClose" class="close-btn"><i class="material-icons">navigate_before</i></div>
        <div class="title">{{ third_level_title }}</div>
        <ul>
          <li v-for="(menu, i) in third_level_menus"><a v-on:click="setLevel3Menus(menu)" :id="menu.id" :href="getHref(menu.link)"><i class="material-icons dot">lens</i>{{ menu.label }}</a></li>
        </ul>
      </div>
    </div>
  `,
  watch: {
    second_level_menus: function(nv, ov) {
      if (nv.length == 0) {
        $('.menu-column-sub').addClass('hide');
      } else {
        $('.menu-column-sub').removeClass('hide');
      }

      if (nv.length != ov.length)
        this.setContentLeftPadding();
    },

    third_level_menus: function(nv, ov) {
      if (nv.length == 0) {
        $('.menu-column-sub2').addClass('hide');
      } else {
        $('.menu-column-sub2').removeClass('hide');
      }

      if (nv.length != ov.length)
        this.setContentLeftPadding();
    }
  },

  mounted: function() {
    var _this = this;
    var active_menu = this.getMenuByPath(this.menus, '/' + this.$root.$route.path.split('/').filter(x => x).join('/'));

    // Visszaépíti a "szint" tömböket
    if (active_menu != undefined) {
      if (active_menu.parents != undefined && active_menu.parents.length > 0) {
        active_menu.parents.map(function(id) {
          var m = _this.getMenuByID(_this.menus, id);

          if (m.subs != undefined && m.subs.length > 0) {
            if (m.level == 1) {
              _this.second_level_menus = m.subs;
            } else if (m.level == 2) {
              _this.third_level_title = m.label;
              _this.third_level_menus = m.subs;
            }
          }
        });
      }
    }

    // Megjeleníti az almenüket
    Vue.nextTick(function() {
      if (active_menu != false) {
        $('#' + active_menu.id).addClass('active');
        if (active_menu.parents != undefined && active_menu.parents.length > 0) {
          active_menu.parents.map(function(id) {
            $('#' + id).addClass('active');
          });
        }
      }
    });
  },

  methods: {
    getMenuByID: function(menus, id) {
      var _this = this;
      var smenu = false;

      menus.map(function(menu) {
        if (menu.id == id)
          smenu = menu;

        if (menu.subs != undefined && menu.subs.length > 0 && smenu == false)
          smenu = _this.getMenuByID(menu.subs, id);
      });

      return smenu;
    },

    getMenuByPath: function(menus, path) {
      var _this = this;
      var smenu = false;

      menus.map(function(menu) {
        if (menu.link == path)
          smenu = menu;

        if (menu.subs != undefined && menu.subs.length > 0 && smenu == false)
          smenu = _this.getMenuByPath(menu.subs, path);
      });

      return smenu;
    },

    getHref: function(link) {
      if (link == '')
        return 'javascript:void(0)';
      else
        return '#' + link;
    },

    setContentLeftPadding: function() {
      Vue.nextTick(function() {
        if (!$('.menu-column-sub').hasClass('hide') && $('.menu-column-sub2').hasClass('hide')) {
          $('.wrapper .content').css({'padding-left': '162px'});
        }

        if (!$('.menu-column-sub').hasClass('hide') && !$('.menu-column-sub2').hasClass('hide')) {
          $('.wrapper .content').css({'padding-left': 162 + $('.menu-column-sub2').outerWidth() });
        }

        if ($('.menu-column-sub').hasClass('hide') && $('.menu-column-sub2').hasClass('hide'))
          $('.wrapper .content').css({'padding-left': '100px'});
      });
    },

    setLevel1Menus: function(menu) {
      if (menu.jump != undefined) {
        var jm = this.getMenuByID(this.menus, menu.jump);
        this.$router.push({path: jm.link});
      }

      if (menu.subs != undefined && menu.subs.length > 0) {
        this.second_level_menus = menu.subs;
      } else {
        this.second_level_menus = [];
      }

      $('.menu-column a').removeClass('active');
      $('#' + menu.id).addClass('active');
    },

    setLevel2Menus: function(menu) {
      if (menu.jump != undefined) {
        var jm = this.getMenuByID(this.menus, menu.jump);
        this.$router.push({path: jm.link});
      }

      if (menu.subs != undefined && menu.subs.length > 0) {
        this.third_level_menus = menu.subs;
        this.third_level_title = menu.label;
      } else {
        this.third_level_menus = [];
        this.third_level_title = '';
      }

      $('.menu-column-sub a').removeClass('active');
      $('#' + menu.id).addClass('active');
      $('.menu-column-sub2 a').removeClass('active');
    },

    setLevel3Menus: function(menu) {
      $('.menu-column-sub2 a').removeClass('active');
      $('#' + menu.id).addClass('active');
    },

    secondLevelMenusClose: function() {
      $('.menu-column-sub2').addClass('hide');
      this.setContentLeftPadding();
    }
  }
});
</script>



// WEBPACK FOOTER //
// tpl_menu.vue?d5c632ca